import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { DocumentViewer } from './DocumentViewer';
import axios from 'axios';

interface ParamTypes {
  orderId: string;
}

interface PropTypes {}

export const MadisonSearchDocuments = (props: PropTypes) => {
  const params: ParamTypes = useParams();
  const [documents, setDocuments] = useState<string[]>();
  const [selectedDocumentUrl, setSelectedDocumentUrl] = useState<string>(null);
  const [defaultDocument, setDefaultDocument] = useState<string>(null);

  const baseGetDocUrl = '/api/archivedReports/getDocument/';

  useEffect(() => {
    getDocuments();
  }, []);

  const getDocuments = async () => {
    var { data } = await axios.get(`/api/archivedReports/getDocumentsForArchivedSearch/${params.orderId}`);
    setDocuments(data);
    if (data.length > 0) {
      const defaultDocument = data[0];
      formatAndSetSelectedDocumentUrl(defaultDocument);
      setDefaultDocument(defaultDocument);
    }
  };

  const formatAndSetSelectedDocumentUrl = (document: string) => {
    setSelectedDocumentUrl(`${baseGetDocUrl}${document.replace(/\//g, '=>')}`);
  };

  return (
    <div>
      {documents?.length > 0 ? (
        <DocumentViewer
          documents={documents}
          defaultDocument={defaultDocument}
          documentUrl={selectedDocumentUrl}
          setDocumentUrl={formatAndSetSelectedDocumentUrl}
          orderId={params.orderId}
        />
      ) : (
        <div>{`No documents available for Madison order ${params.orderId}`}</div>
      )}
    </div>
  );
};
